export enum MarketingSourceEnum {
  MARKETING_ACTIVITY = 'Marketing Activity',
  NONE = 'None',
}
